export default __webpack_public_path__ + "static/media/R50.1a5d31d7.png";